/*
 * @Author: qiaoshiteng
 * @Date: 2023-06-14 11:12:47
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2023-07-28 11:03:33
 * @Description: 
 */
export default {
	state: {
		keepLiveRoute: [],
		routeKey: null,
		querylist:{},
		routeShow: true,
		warningList:[],
		typeList:[],
	},
	mutations: {
		pushKeepLive(state, component){
			if(!state.keepLiveRoute.includes(component)){
				state.keepLiveRoute.push(component)
			}
		},
		removeKeepLive(state, component){
			var index = state.keepLiveRoute.indexOf(component);
			if(index !== -1){
				state.keepLiveRoute.splice(index, 1);
			}
		},
		clearKeepLive(state){
			state.keepLiveRoute = []
		},
		setRouteKey(state, key){
			state.routeKey = key
		},
		setRouteShow(state, key){
			state.routeShow = key
		},
		setquery(state,key){
			state.querylist=key
		},
		setwarningList(state,key){
			state.warningList=key
		},
		settypeList(state,key){
			state.typeList=key
		},
		clearnquery(state){
			state.querylist={}
		},
		clearnsettypeList(state){
			state.typeList=[]
		}
	},
	actions: {
		setRouteKey({ commit }, key) {
			commit('setRouteKey', key);
		}
	}
}
